
import React, { useState } from "react";
import { Input, Tabs } from "antd";
import { Users, ShoppingCart } from "react-feather";
import FrontOfficeReports from "./frontOfficeReports";
import RoomServiceReports from "./RoomServiceReports";

const { Search } = Input;
const { TabPane } = Tabs;

const ReportLandingPage = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [activeTab, setActiveTab] = useState("frontOffice");

  const handleSearch = (value) => {
    setSearchQuery(value.toLowerCase());
  };

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <div className="page-header d-flex justify-content-between align-items-center mb-4">
          <div>
            <h3 className="page-title" style={{ fontSize: "24px", fontWeight: "600" }}>
              Analytical and MIS Reports
            </h3>
            <p className="page-subtitle" style={{ fontSize: "14px", color: "#666" }}>
              Comprehensive reporting for Front Office and Room Service & POS to monitor financials, occupancy, and sales trends.
            </p>
          </div>
          <div className="filter-section">
            <Search
              placeholder="Search reports..."
              allowClear
              enterButton
              onSearch={handleSearch}
              style={{ width: "300px" }}
            />
          </div>
        </div>
        <div className="form-bg" style={{ backgroundColor: "#fff", padding: "20px", borderRadius: "8px" }}>
          <Tabs
            defaultActiveKey="frontOffice"
            onChange={setActiveTab}
            size="large"
            tabBarStyle={{ fontSize: "18px", fontWeight: "400" }}
          >
            <TabPane
              tab={
                <span>
                  <Users style={{ marginRight: "5px" }} />
                  Front Office Reports
                </span>
              }
              key="frontOffice"
            >
              <FrontOfficeReports searchQuery={searchQuery} />
            </TabPane>
            <TabPane
              tab={
                <span>
                  <ShoppingCart style={{ marginRight: "5px" }} />
                  Room Service & POS Reports
                </span>
              }
              key="roomService"
            >
              <RoomServiceReports searchQuery={searchQuery} />
            </TabPane>
          </Tabs>
        </div>
      </div>
    </div>
  );
};

export default ReportLandingPage;
